// extracted by mini-css-extract-plugin
export default {"rootContainer":"DescriptionField_rootContainer__dC929","placeHolder":"DescriptionField_placeHolder__CM7MS"};